import { MutableRefObject } from "react";
import KeywordTransformer from "./keywordTransformer";

export async function openDialog(
  dialogURL: string,
  context: MutableRefObject<Office.Dialog | undefined>,
  messageHandler: (args: any) => void
) {
  Office.context.ui.displayDialogAsync(dialogURL, { height: 60, width: 30, asyncContext: context }, function (result) {
    const dialogRef = result.asyncContext as MutableRefObject<Office.Dialog>;
    if (result.status === Office.AsyncResultStatus.Failed) {
      console.error(`${result.error.code}: ${result.error.message}`);
    } else {
      dialogRef.current = result.value;
      dialogRef.current.addEventHandler(Office.EventType.DialogMessageReceived, messageHandler);
    }
  });
}

export function textToTsQueryText(text: string) {
  const keywordTransformer = new KeywordTransformer();
  return keywordTransformer.forwardTransform(text);
}

export function textToSanitizedKeywordsText(text: string) {
  const keywordTransformer = new KeywordTransformer();
  return keywordTransformer.sanitize(text);
}
